import { render, staticRenderFns } from "./MasterRole.vue?vue&type=template&id=11e0ace1&"
import script from "./MasterRole.vue?vue&type=script&lang=js&"
export * from "./MasterRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports